/**
 {
    method: "GET",
    path: "/underwriting/user_pipeline",
    title: "Fetch User Pipeline",
    description: "Returns an array of loans.",
    purpose:
      "Retrieves the loan pipeline for a specific user. If user role is admin, all loans are returned.",
    examplePath: null,
    requiredParams: null,
    requestPayload: null,
    requestResponse: null,
  },
 */

import { getLoanByIdRequestResponse } from "./routeConfigExampleData/getLoanByIdRequestResponse";
import { updateLoanDataRequestResponse } from "./routeConfigExampleData/updateLoanDataRequestResponse";

export const underwritingRoutesConfig = [
  // TEMPALTE
  {
    method: "POST",
    title: "Create Loan",
    path: "/underwriting/create_loan",
    examplePath: null,
    description: "Creates a new loan.",
    purpose: null,

    requiredParams: null,
    requestPayload: {
      borrowers: [
        {
          ff_sold: { less_than_three_years: 0, greater_than_three_years: 0 },
          ff_retained_as_rental: {
            less_than_three_years: 0,
            greater_than_three_years: 0,
          },
          income_producing_properties: {
            less_than_three_years: 0,
            greater_than_three_years: 0,
          },
          guc_sold: { less_than_three_years: 0, greater_than_three_years: 0 },
          guc_retained_as_rental: {
            less_than_three_years: 0,
            greater_than_three_years: 0,
          },
          general_contractor_projects: {
            less_than_three_years: 0,
            greater_than_three_years: 0,
          },
          firstName: "Bill",
          lastName: "Smith",
        },
      ],
      subjectProperties: [
        {
          address: {
            id: "Av-3sHObVHP0F5_LN7rocg-1760552583459",
            fullAddress: "123 Main Street, Chardon, OH 44024",
            streetNumber: "123",
            streetName: "Main Street",
            zip: "44024",
            county: "Geauga",
            state: "OH",
            city: "Chardon",
            country: "United States",
            countryCode: "US",
            latitude: 41.581462,
            longitude: -81.204155,
            coordinateTuple: [41.581462, -81.204155],
            score: 0.9199921923536415,
          },
        },
      ],
      pipeline: "Underwriting",
      salesperson: "joliva@cliffcomortgage.com",
      permittedUsers: ["dev1@cliffcomortgage.com"],
      loanProductType: "DSCR",
      loanPurpose: "Purchase",
      loanName: "123 Main Street, Chardon, OH 44024",
    },
    requestResponse:
      "Unsure of exact return because I don't want to create an unnecessary loan",
  },
  {
    method: "GET",
    title: "Get Loan By ID",
    path: "/underwriting/loan/{loanId}",
    examplePath: "underwriting/loan/67f44f69e685b472c479f7dd",
    description: "Retrieves the full data of a loan by its ID.",
    purpose:
      "Retrieves full data of a the loan, included the list of items that are omitted from the pipeline endpoint. Used on the Loan Details page to populate all loan details.",

    requiredParams: null,
    requestPayload: null,
    requestResponse: getLoanByIdRequestResponse,
  },
  {
    method: "POST",
    title: "Update Loan Data",
    path: "/underwriting/update_loan_data/{loanId}",
    examplePath: "underwriting/update_loan_data/67f44f69e685b472c479f7dd",
    description: "Updates the loan data for a specific loan.",
    purpose:
      "Payload consists of only the intended updated values. Returns the full loan with the updated values",

    requiredParams: null,
    requestPayload: {
      expectedClosingDate: "2025-12-02T00:00:00.000Z",
    },
    requestResponse: updateLoanDataRequestResponse,
  },
  {
    method: "POST",
    path: "/underwriting/create_association/{dealId}/{associationTypeName}/{associationTypeId}",
    title: "Create Association",
    description:
      "Creates a new association between a deal and a specific entity.",
    purpose:
      "Establishes a relationship between the deal and the specified entity.",
    examplePath: null,
    requiredParams: null,
    requestPayload: {
      loanDocuments: ["68d70aeaf5762dc2a0685688", "68d70856a6935b71e14f5d1d"],
      borrowers: ["68a61f68982207f5ea3d8018"],
      subjectProperties: ["67f44f69e685b472c479f7de"],
    },
    requestResponse: "Returns the full updated loan object",
  },
];
